import httpService from "../components/service";
import cacheService from "@/services/cache";

window.connectionBO = {
    apiCategories: "/admin/{id}/categories/list",
    apiInfosCategory: "/admin/category/",
    apiPreferernce: "/preference",
    apiOrdersDetails: "/orders/{id}",
    apiOrdersList: "/orders",
    apiCountDown: "/countdowns",
    apiStar: "/components/{id}/star",
    apiDeleteBrandUser: "/admin/manager/user/{id}/delete",
    apiAccessUser: "/admin/manager/user/{id}/active",
    // apiListCountDown: '/countdowns/{id}',

    /**
     * return list categiries / Sous Categories
     * @param value
     * @returns {Promise<any>}
     */
    getCategoriesList(value) {
        return new Promise((resolve, reject) => {
            httpService
                .get(this.apiCategories.replace("{id}", value))
                .then(response => resolve(response))
                .catch(() => reject());
        });
    },
    /**
     * return orders
     * @param value
     * @returns {Promise<any>}
     */
    getOrdersDetail(value) {
        return new Promise((resolve, reject) => {
            httpService
                .get(this.apiOrdersDetails.replace("{id}", value))
                .then(response => resolve(response))
                .catch(() => reject());
        });
    },
    /**
     * return list orders
     * @returns {Promise<any>}
     */
    getOrdersList() {
        return new Promise((resolve, reject) => {
            httpService
                .get(this.apiOrdersList)
                .then(response => resolve(response))
                .catch(() => reject());
        });
    },

    /**
     * return Json localstorage
     * @returns {any}
     */
    getUsersData() {
        return cacheService.getRem3rchUser();
    },

    /**
     * Return infos category
     * @param value
     * @returns {Promise<any>}
     */
    getThisSubCat(value) {
        return new Promise((resolve, reject) => {
            httpService
                .get(this.apiInfosCategory + value)
                .then(response => resolve(response))
                .catch(() => reject());
        });
    },
    /**
     * Return preference User
     * @returns {Promise<any>}
     */
    getPreferences() {
        return new Promise((resolve, reject) => {
            httpService
                .get(this.apiPreferernce)
                .then(response => resolve(response))
                .catch(() => reject());
        });
    },
    async postPreference(obj) {
        const res = await httpService.post(this.apiPreferernce, JSON.stringify(obj));
        if (res.code) throw res.message;
        return res;
    },
    async putPreference(obj) {
        await httpService.put(this.apiPreferernce, JSON.stringify(obj));
    },
    /**
     *
     * @param value
     * @returns {*}
     * @constructor
     */
    putBrandUser(idUser, data) {
        return httpService.put(this.apiDeleteBrandUser.replace("{id}", idUser), JSON.stringify(data));
    },

    putAccessUser(idUser, data) {
        return httpService.put(this.apiAccessUser.replace("{id}", idUser), JSON.stringify(data));
    },
    /**
     *
     * @param obj
     * @returns {*}
     */
    postCountDown(obj) {
        return httpService.post(this.apiCountDown, JSON.stringify(obj));
    },
    putCountDown(id, obj) {
        return httpService.put(this.apiCountDown + "/" + id, JSON.stringify(obj));
    },
    /**
     *
     * @param status star
     * @param id
     * @returns {*}
     */
    putStar(status, id) {
        return httpService.put(this.apiStar.replace("{id}", id), JSON.stringify({ isStar: status }));
    },
    /**
     * Get list count down
     * @param value
     * @returns {Promise<any>}
     */
    getListCountDown(value) {
        return new Promise((resolve, reject) => {
            httpService
                .get(this.apiCountDown)
                .then(response => resolve(response))
                .catch(() => reject());
        });
    }
};

export default connectionBO;



// WEBPACK FOOTER //
// ./src/services/connectionBO.js